export default class NewsLoadMore {

    constructor() {
        this.settings = {
            $postsList : $(".js-news-articles-list")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$postsList != null) {

            let postsList = this.settings.$postsList;
            let nrLoadMore = $('#js-nr-posts-default').val();
            let loadMoreBtn = $(".js-news-load-more");

            function postTypeList() {
                $('.js-news-article-single').removeClass('hidden');

                postsList.find('.js-news-article-single').each(function (index) {

                    // Hide articles
                    if (index >= nrLoadMore) {
                        $(this).addClass('hidden');
                    }
                });
            }


            function updateShowingNr() {
                let showingNr = postsList.find('.js-news-article-single:not(.hidden)').length;

                $('.js-current-news-nr').each(function() {
                    $(this).text(showingNr);
                });
            }

            postTypeList();
            updateShowingNr();

            if (postsList.find('.js-news-article-single.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            loadMoreBtn.on('click', function () {

                let morePosts = postsList.find('.js-news-article-single.hidden');
                let counter = 0;


                morePosts.each(function () {

                    // Show more articles
                    if (counter >= nrLoadMore) {
                        return false;
                    }

                    counter++;

                    $(this).removeClass('hidden');
                });

                if (postsList.find('.js-news-article-single.hidden').length === 0) {
                    $(this).removeClass('btn');
                    $(this).addClass('hidden');
                }

                updateShowingNr();
            });

        }

    }
};
$(document).ready(() => {
    new NewsLoadMore();
});